import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/movement/pageContext';

export const MovementErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	/** Possible to implement custom view based on error instead of throwing */
	throw new Error(`Failed to retrieve data for Movement page (error: ${error})`);
};
